import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface LoadingProps {
  message?: string
  fullScreen?: boolean
  className?: string
}

export default function Loading({ message = 'Cargando...', fullScreen = false, className }: LoadingProps) {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="text-center animate-in fade-in zoom-in-95 duration-200">
          <Loader2 className="w-12 h-12 animate-spin text-primary mx-auto mb-4" />
          <p className="text-muted-foreground font-medium">{message}</p>
        </div>
      </div>
    )
  }

  return (
    <div className={cn("flex items-center justify-center py-12", className)}>
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto mb-2" />
        <p className="text-muted-foreground text-sm">{message}</p>
      </div>
    </div>
  )
}